<template>
  <div class="error-page">
    <div class="content">
      <Resource
        :src="getFeUrl(isChinese() ? '/youyan-platform/png/no-data.png' : '/rendora/404.png')"
        :transform-resource="transformImage"
        class="mx-auto"
        :class="isChinese() ? 'w-[200px] h-[200px]' : 'w-[944px] h-[321px]'"
      />
      <div
        class="text-font-80 font-bold"
        :class="isChinese() ? 'text-[18px] my-[30px]' : 'text-[30px] mt-[15px] mb-[24px]'"
      >
        {{ $t('zan-wu-quan-xian-fang-wen') }}
      </div>
      <a-button
        type="primary"
        @click="goHome"
        :class="!isChinese() && 'w-[240px] h-[42px] rounded-[15px]'"
      >
        {{ $t('fan-hui-shou-ye') }}
      </a-button>
      <p class="mt-2">{{ $t('0-s-hou-zi-dong-fan-hui', [second]) }}</p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { transformImage } from '~/utils';
import { isChinese } from '~/utils/area';
import { goHome } from '~/utils/permission';
import { getFeUrl } from '~/utils/url';

const router = useRouter();

const second = ref(3);
let timer: NodeJS.Timeout;

onMounted(() => {
  timer = setInterval(() => {
    if (second.value <= 0) {
      clearInterval(timer);
      location.href = '/';
      return;
    }
    second.value--;
  }, 1000);
});
</script>
<style lang="scss" scoped>
.error-page {
  padding-top: $top-height;
  height: calc(100vh - $top-height);

  .content {
    @apply flex flex-col justify-center h-full items-center mx-auto text-center;
  }
}
</style>
